// Cache identity for the SQLite WebAssembly binary, kept separate from sqliteDatabase.ts so the
// keep-or-delete rule is unit-testable without a browser, OPFS, or IndexedDB.
//
// The browser glue sql.js ships (dist/sql-wasm-browser.js) binds emscripten exports by single letter
// and calls `exports.O()` as _initialize. Those letters are assigned per link order, so a binary from
// any other sql.js release throws "Qt.O is not a function" from inside the glue's own promise chain —
// a rejection that initSqlJs never surfaces, so boot hangs instead of failing. Vite fingerprints the
// emitted asset filename, so keying the cache by that name guarantees a cached binary can only have
// been written by the build whose glue it is paired with.

export const WASM_IDB_KEY_PREFIX = 'sqlite_wasm_binary:';

// Entries written before the fingerprint scheme — including binaries pulled by the old CDN fallbacks
// pinned to sql.js 1.14.2 — must never be readable again.
export const LEGACY_WASM_IDB_KEYS: readonly string[] = ['sqlite_wasm_binary_cache_v1'];
export const LEGACY_WASM_OPFS_FILES: readonly string[] = ['sql-wasm.wasm'];

const CACHED_WASM_FILE_PATTERN = /^sql-wasm-browser-[^/]+\.wasm$/;

// The emitted asset filename doubles as the cache id, e.g. sql-wasm-browser-Cz1_9kQw.wasm
export function wasmCacheId(assetUrl: string): string {
  return assetUrl.split(/[?#]/)[0].split('/').pop() || 'sql-wasm-browser.wasm';
}

export function wasmIdbKey(id: string): string {
  return `${WASM_IDB_KEY_PREFIX}${id}`;
}

export function isStaleWasmOpfsEntry(name: string, currentId: string): boolean {
  if (name === currentId) return false;
  return LEGACY_WASM_OPFS_FILES.includes(name) || CACHED_WASM_FILE_PATTERN.test(name);
}

export function isStaleWasmIdbEntry(key: string, currentId: string): boolean {
  if (key === wasmIdbKey(currentId)) return false;
  return LEGACY_WASM_IDB_KEYS.includes(key) || key.startsWith(WASM_IDB_KEY_PREFIX);
}
